import styled from 'styled-components';

export const WithCreditStudyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  height: calc(100vh - 100px);
`;

export const CotenantCardDescription = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  gap: 16px;
  margin-top: 16px;
  background: #ffffff;
  box-shadow: 0px 10px 25px rgba(120, 120, 120, 0.06);
  border-radius: 24px;
  font-family: 'Satoshi';
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #6c757d;
`;
export const CotenantDescriptionParagraph = styled.p`
  margin: 0px;
  & > strong {
    color: #000000;
  }
`;

export const CotenantDescriptionImportant = styled.p`
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #000000;
  margin: 0px;
  & > span {
    color: #0055fb;
  }
`;
